module.exports = __webpack_public_path__ + "static/media/Lesson-10-15-Faith-and-Treasure.6ac54762.pdf";